<template>
  <div class="relative lg:inline-block text-left mt-2 lg:mt-0 ">
    <BaseDropdown
      :options="filterOptions"
      trigger="hover"
      divide-items
      large-items
      class="w-full"
    >
      <div class="relative lg:inline-block text-left w-full">
        <BaseButton
          variant="white-secondary"
          class="group"
          block
        >
          <div
            v-if="$useNewLayout"
            class="mr-1"
          >
            {{ $t('Date only') }}:
          </div>
          <i
            v-else
            class="fas fa-calendar-days mr-2"
          />
          <span
            class="group-hover:text-white"
            :class="{
              'text-primary-500': showDateOnly,
              'text-gray-500': !showDateOnly,
            }"
          >
            {{ showDateOnly ? $t('Yes') : $t('No') }}
          </span>
        </BaseButton>
      </div>
      <template #menu-header>
        <div class="px-4 py-2 bg-gray-50 text-gray-500 rounded-t-md sticky top-0 border-b border-gray-200">
          <span class="text-sm font-medium truncate">
            {{ title || $t('Only show tasks with a date?') }}
          </span>
        </div>
      </template>
    </BaseDropdown>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    columns: {
      type: Array,
      default: () => []
    },
    defaultFilter: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showDateOnly: this.defaultFilter || false,
    }
  },
  computed: {
    filterOptions() {
      return [
        {
          label: this.$t('No'),
          action: () => this.setValue(false),
          variant: !this.showDateOnly ? 'active' : ''
        },
        {
          label: this.$t('Yes'),
          action: () => this.setValue(true),
          variant: this.showDateOnly ? 'active' : ''
        }
      ]
    }
  },
  methods: {
    setValue(value) {
      this.showDateOnly = value
      this.$emit('change', this.showDateOnly)
    }
  },
  watch: {
    defaultFilter() {
      this.showDateOnly = this.defaultFilter || false
    }
  }
}
</script>
